/**
 * TimeTimeoutzone
 */
export const Timeout = (function () {

  var init = function () {
    addEventListeners();
  }
  /**
   * EVENT LISTENER FUNCTIONS
   */
  function addEventListeners() {
    $('.myds-timeout-select').on('change', function (event) {
      var selected = $(this).find(':selected').val();
      var promise = update(selected);
      handleResponse(promise);
    });
    /**
     * Add a listener to all ajax success functions that look for a timeout
     * header. 
     */
    $(document).ajaxSuccess(function(event, request, settings) {
      if (request.getResponseHeader('X-Timeout') === '1') {
        window.location = '/?timeout=true';
      }
    });
  }
  /**
   * HTTP FUNCTIONS
   */
  function update(selected) {
    var csrf = Util.getCSRF();
    return $.ajax({
      url: `/variables/mydex_preferences_user_timeout/update`,
      type: 'post',
      data:  {
        value : selected
      },
      headers: {
        'x-csrf-token': csrf
      },
    });
  }

  function handleResponse( promise ) {
    promise.then(function () {
        Util.toggleAlert('.alert', "Success: Timeout Changed!", 'alert-success');
        resetForm(form);
    });
    promise.fail(function (response) {
        var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
        Util.toggleAlert('.alert', message , 'alert-warning');
    }); 
  }

  return {
    init: init
  }

}());


